import { baseHeaders } from '@constants'

const stateSuffix = 'V6'

const prepareHeaders = (headers, { getState }) => {
  Object.keys(baseHeaders).forEach((key) => headers.set(key, baseHeaders[key]))

  const store = getState().auth.store

  if (store.id && store.secret_key) {
    headers.set('Authorization', `Basic ${btoa(`${store.id}:${store.secret_key}`)}`)

    return headers
  }

  const token = getState().auth.jwtToken

  if (token) {
    headers.set('Authorization', `JWT ${token}`)
  }

  return headers
}

const transformResponse = (i) => (i || {}).data || null

const getStateFromLocalStorage = (sliceName) => {
  if (!window.localStorage || !window.localStorage.getItem) {
    return {}
  }

  const savedState = window.localStorage.getItem(`${sliceName}State${stateSuffix}`)

  if (savedState) {
    return JSON.parse(savedState)
  }

  return {}
}

const storeStateAtLocalStorage = (sliceName, state) => {
  const key = `${sliceName}State${stateSuffix}`
  const savedState = window.localStorage.getItem(key)

  if (savedState) {
    return window.localStorage.setItem(key, JSON.stringify({ ...JSON.parse(savedState), ...state }))
  }

  return window.localStorage.setItem(key, JSON.stringify(state))
}


export { prepareHeaders, transformResponse, getStateFromLocalStorage, storeStateAtLocalStorage }
